"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vehiclesMiddleware = void 0;
const actions_1 = require("../../actions");
const vehicles_1 = require("../../actions/vehicles");
const vehiclesMiddleware = () => (next) => (action) => {
    switch (action.type) {
        case vehicles_1.INCREMENTAL_RESPONSE_VEHICLES:
            const response = action.payload || {};
            const { vehicleBasic: vehicles = [] } = response;
            const vehicleIds = (vehicles || []).map((vehicle) => vehicle.id);
            next([
                actions_1.ACTIONS.VEHICLES.setVehicles({ vehicles }),
                actions_1.ACTIONS.RESULT_VEHICLEIDS.addResultVehicleIds({ vehicleIds }),
            ]);
            break;
        default:
            next(action);
    }
};
exports.vehiclesMiddleware = vehiclesMiddleware;
//# sourceMappingURL=vehicles.middleware.js.map